// Returns the style for a map element adapted to the current zoom level of the
// map
//
export default function getMapConfiguration(zoomLevel, map) {
  const zoomSpecificConfiguration = map.zoomLevels.find(
    zoomLevelConfiguration =>
      zoomLevel >= zoomLevelConfiguration.zoomLevelMin &&
      zoomLevel <= zoomLevelConfiguration.zoomLevelMax
  );

  // If there's no zoom level specific configuration for the current zoom level,
  // we just return the root map object from which every map attribute is
  // contained
  return zoomSpecificConfiguration || map;
}
